import styled from "@emotion/styled";

export const Logo = styled.img`
  inline-size: 24px;
  block-size: 24px;
  margin-inline-end: 8px;

  border-radius: 50%;
`;
